var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2DCD5F3F-D3A7-47D0-B5C6-6C4B10F21C8D@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Profile-&-Settings-\\uD83D\\uDC81\\uD83C\\uDFFB\\u200D\\u2640\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Edit-Profile---Photos",
    transform: "translate(-255.000000, -321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(21.000000, 321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus-button",
    transform: "translate(234.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,0 L95,0 C97.7614237,-5.07265313e-16 100,2.23857625 100,5 L100,95 C100,97.7614237 97.7614237,100 95,100 L5,100 C2.23857625,100 3.38176876e-16,97.7614237 0,95 L0,5 C-3.38176876e-16,2.23857625 2.23857625,5.07265313e-16 5,0 Z",
    id: "Rectangle-8-Copy-2",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "+",
    fill: "#CFCFCF",
    opacity: 0.778362772,
    points: "59.611886 51.9793074 52.7445467 51.9793074 52.7445467 59.5613503 48.0673319 59.5613503 48.0673319 51.9793074 41.2371134 51.9793074 41.2371134 47.7501277 48.0673319 47.7501277 48.0673319 40.2061856 52.7445467 40.2061856 52.7445467 47.7501277 59.611886 47.7501277"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.215b88c4221f575b169396c5ad146544.svg";
export { ForwardRef as ReactComponent };